import { useState, useEffect } from 'react';
import get from 'lodash/get';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { type fetchLicenseInformationResponse, ACTIVE } from './types';

export const getLicenseInformationUrl = (cloudId: string) =>
	`/gateway/api/xflow/${cloudId}/license-information`;

export const fetchLicenseInformation = async (cloudId: string) =>
	performGetRequest(getLicenseInformationUrl(cloudId));

export const getOpsgenieApplicationUrl = (applicationUrl: string) => {
	const currentInstanceName = window.location.hostname.replace(
		/(\.jira(-dev)?)?\.com$|(\.atlassian)?\.net$/,
		'',
	);

	if (applicationUrl && currentInstanceName && applicationUrl.includes(currentInstanceName)) {
		return applicationUrl;
	}

	return null;
};

type LicenseInformationState = {
	loading: boolean;
	data: fetchLicenseInformationResponse | null;
	error: Error | null;
};

export const useLicenseInformation = () => {
	const [state, setState] = useState<LicenseInformationState>({
		loading: true,
		data: null,
		error: null,
	});
	const cloudId = useCloudId();

	useEffect(() => {
		const fetchInstanceData = async () => {
			setState({
				loading: true,
				data: null,
				error: null,
			});
			try {
				const licenseInformation = await fetchLicenseInformation(cloudId);
				setState({
					loading: false,
					data: licenseInformation,
					error: null,
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				log.safeWarnWithoutCustomerData(
					'growth.cross-flow.utils',
					'There was an error fetching license information',
					err,
				);
				setState({
					loading: false,
					data: null,
					error: err,
				});
			}
		};
		fetchInstanceData();
	}, [cloudId]);

	return state;
};

export const useHasProduct = (productKey: string) => {
	const { loading, data, error } = useLicenseInformation();
	const isActive = get(data, ['products', productKey, 'state'], null) === ACTIVE;
	return { loading, isActive, error };
};

export const getOpsgenieInstanceUrl = async (): Promise<string | null> => {
	try {
		const { cloudId } = getTenantContext_DEPRECATED_DO_NOT_USE();
		const licenses = await fetchLicenseInformation(cloudId);

		if (
			licenses &&
			licenses.products &&
			licenses.products.opsgenie &&
			licenses.products.opsgenie.applicationUrl
		) {
			return getOpsgenieApplicationUrl(licenses.products.opsgenie.applicationUrl);
		}

		return null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		log.safeWarnWithoutCustomerData(
			'growth.megaphone.touchpoint.experiment',
			'There was an error fetching license information',
			error,
		);
		return null;
	}
};
